module.exports = __webpack_public_path__ + "img/fault-item_bg.152ddb6f.png";